module.exports = __webpack_public_path__ + "images/emoji/electric_plug.61eb1dcaa53e5ca64292.png";